<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>

<script>
import wxApi from '@/assets/publicJS/WeChatShare.js';
export default {
    name: 'App',
    beforeCreate() {
        function getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
        // 分享地址进来更新地址
        if (getQueryString('isappinstalled') === '0') {
            window.location.replace(window.location.href.replace(window.location.search, ''));
            return false;
        }
    },
    created() {
        //判断登录设备
        this.whatEquipment()
        // 判断是否微信打开
        this.is_wechat();

    },
    mounted() {
        //微信分享获取权限
        // this.wxShare();
    },

    methods: {
        //判断登录设备
        whatEquipment() {
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            this.is_PC = flag;
            this.$store.commit('is_PC', this.is_PC);
        },
        //判断是否微信登录
        is_wechat() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                this.$store.commit('updateIsWechat', true);
            } else {
                this.$store.commit('updateIsWechat', false);
            }
        },
        // 判断设备为 ios
        isIos() {
            var u = navigator.userAgent;
            if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
                this.$store.commit('updateIsIos', true);
            }
            this.$store.commit('updateIsIos', false);
        },
        //分享
        wxShare() {
            // 将配置注入通用方法
            wxApi.wxRegister();
        },
    },
}
</script>

<style>
@import './assets/fonts/font.css';

#app {}

a {
    text-decoration: none;
    color: #333 !important;
}

p {
    display: block;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

body {
    font-family: HelveticaNeueLTPro-ThEx;

}

body>>>[class*=" el-icon-"],
body>>>[class^=el-icon-] {
    font-family: element-icons !important;
}

html,
body {
    font: 12px Arial, "微软雅黑";
    color: #666;
    width: 100%;
    /* height: 100%; */
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-overflow-scrolling: touch;
    /* overflow-scrolling: touch; */

}

ul {
    margin: 0;
    padding: 0;
}

ul li {
    list-style-type: none;
}

.el-breadcrumb {
    margin-bottom: 40px;
    font-size: 14px;
}

.el-image {
    color: #fff !important;
}
</style>